/* Perky — storefront behaviour. No dependencies. */
(function () {
  'use strict';

  /* ------------------------------------------------------------ mobile nav */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (!toggle) return;
    var nav = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!nav) return;
    var open = nav.getAttribute('data-open') === 'true';
    nav.setAttribute('data-open', String(!open));
    toggle.setAttribute('aria-expanded', String(!open));
  });

  /* -------------------------------------------------------- qty steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;

    var min = parseInt(input.getAttribute('min') || '1', 10);
    var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    var next = (parseInt(input.value, 10) || min) + step;
    if (next < min) next = min;
    input.value = next;
    // Cart line items post on change; the PDP input does not need to.
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------- cart line qty */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var form = input.closest('form');
    if (form) form.submit();
  });

  /* --------------------------------------------------------- pdp gallery */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    if (!main) return;

    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full) {
          main.src = full;
          main.srcset = '';
          main.alt = thumb.getAttribute('data-alt') || main.alt;
        }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', String(t === thumb));
        });
      });
    });
  });

  /* -------------------------------------------------------- variant picker
     Reads the option inputs, finds the matching variant from the JSON blob
     Liquid rendered, and keeps price / availability / image / URL in sync. */
  document.querySelectorAll('[data-variant-picker]').forEach(function (root) {
    // Look inside the picker first; fall back to any sibling or
    // ancestor-scoped script (older templates rendered it as a sibling).
    var dataEl =
      root.querySelector('[data-variant-json]') ||
      (root.parentNode && root.parentNode.querySelector('[data-variant-json]')) ||
      document.querySelector('[data-variant-json]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }
    if (!Array.isArray(variants) || !variants.length) return;

    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-add]');
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

    function money(cents) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      value = parts.join('.');
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, value);
    }

    function selectedOptions() {
      return Array.prototype.map.call(
        root.querySelectorAll('[data-option-index]'),
        function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        }
      );
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (o, i) {
          return o === null || v.options[i] === o;
        });
      });
    }

    function update() {
      var opts = selectedOptions();

      // Update the "selected value" label next to each option name.
      opts.forEach(function (val, i) {
        var label = root.querySelector('[data-selected-option-index="' + i + '"]');
        if (label && val !== null) label.textContent = val;
      });

      // Grey out option values that pair with nothing purchasable.
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        group.querySelectorAll('input').forEach(function (input) {
          var probe = opts.slice();
          probe[idx] = input.value;
          var match = variants.find(function (v) {
            return probe.every(function (o, i) {
              return o === null || v.options[i] === o;
            });
          });
          input.disabled = !match || !match.available;
        });
      });

      var variant = findVariant(opts);

      if (!variant) {
        if (addBtn) {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.textContent = 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceEl) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s>' + money(variant.compare_at_price) + '</s> ';
        }
        html += money(variant.price);
        priceEl.innerHTML = html;
      }

      if (addBtn) {
        if (variant.available) {
          addBtn.removeAttribute('disabled');
          addBtn.textContent = addBtn.getAttribute('data-add-text') || 'Add to cart';
        } else {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.textContent = 'Sold out';
        }
      }

      if (variant.featured_image) {
        var main = document.querySelector('[data-gallery-main]');
        if (main) {
          main.src = variant.featured_image;
          main.srcset = '';
        }
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
    });

    update();
  });
})();
